module.exports = __webpack_public_path__ + "img/hi-hero.95980676.svg";